'use strict';

import uikit from '../uikit';

import {createPromotionalGiveaway} from '../components/PromotionalGiveaway/PromotionalGiveaway';

export class PromotionalGiveawayEntryPoint extends uikit.EntryPoint {
  register() {
    uikit.components.register(createPromotionalGiveaway, { priority: false, ajaxable: true });  
  }
}


// WEBPACK FOOTER //
// ./assets/entryPoints/PromoGiveawayEntryPoint.js